export class State {
  text: string = "";
  active: boolean = false;
  theme: string = "danger";
}
